var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"mainForm",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('CarteIdentification',{staticClass:"mb-6",attrs:{"identification":_vm.identification,"showDateNaissance":"","showSexe":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }